/* eslint-disable max-len */
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      idConfigActionBtn: 'configActionBtn',
      idConfigIconActionBtn: 'configIconActionBtn',
      isOpenConfigActionBtn: false,
      selectedBtn: null,
      selectedIndexBtn: null,
    };
  },

  watch: {
    showModalIconActionBtn(val) {
      if (val) {
        setTimeout(() => {
          const element = document.getElementById(this.idConfigIconActionBtn);
          if (element) element.classList.add('show');
        }, 300);
      }
    },

    showModalScriptActionBtn(val) {
      if (typeof this.$refs.modalScriptActionBtn !== 'undefined') {
        if (val) {
          this.$refs.modalScriptActionBtn.show();
        } else {
          this.$refs.modalScriptActionBtn.hide();
        }
      }
    },
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', ['showModalScriptActionBtn', 'showModalIconActionBtn']),
  },

  methods: {
    ...mapActions('jStoreExperienceManagerV2', ['toggleModalIconActionBtn']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),

    openConfigActionButton(column, index) {
      if (this.selectedBtn) {
        this.toggleConfigurationActionBtn(false);

        setTimeout(() => {
          this.selectedBtn = column;
          this.selectedIndexBtn = index;
          this.toggleConfigurationActionBtn(true);
        }, 250);
      } else {
        this.selectedBtn = column;
        this.selectedIndexBtn = index;
        this.toggleConfigurationActionBtn(true);
      }
    },

    toggleConfigurationActionBtn(status) {
      if (status) {
        this.isOpenConfigActionBtn = true;

        setTimeout(() => {
          const element = document.getElementById(this.idConfigActionBtn);
          const elementParent = document.getElementById(this.id);
          if (element) element.classList.add('show-properties-field');
          if (elementParent) elementParent.classList.add('show-properties-group');
        }, 200);
      } else {
        const element = document.getElementById(this.idConfigActionBtn);
        const elementParent = document.getElementById(this.id);
        if (element) element.classList.remove('show-properties-field');
        if (elementParent) elementParent.classList.remove('show-properties-group');

        setTimeout(() => {
          this.isOpenConfigActionBtn = false;
          this.selectedBtn = null;
          this.selectedIndexBtn = null;
        }, 200);
      }
    },

    submitActionButton(mode, params, onTable) {
      if (params.key) {
        const findKeySame = this.dataSetup.action_buttons.find(e => e.key === params.key);
        if (mode === 'add') {
          if (!findKeySame) {
            if (!onTable) this.setChangesValueView(true);
            this.dataSetup.action_buttons.push(params);
          } else {
            this.toggleProblem('Key cannot be the same!');
          }
        } else {
          // eslint-disable-next-line
          if (this.selectedBtn.key === params.key) {
            if (!onTable) this.setChangesValueView(true);
            this.dataSetup.action_buttons[this.selectedIndexBtn] = params;
          } else {
            // eslint-disable-next-line
            if (!findKeySame) {
              if (!onTable) this.setChangesValueView(true);
              this.dataSetup.action_buttons[this.selectedIndexBtn] = params;
            } else {
              this.toggleProblem('Key cannot be the same!');
            }
          }
        }
      } else {
        this.dataSetup.action_buttons.splice(this.selectedIndexBtn, 1);
      }

      this.toggleConfigurationActionBtn(false);
    },

    deleteActionButton(index, onTable) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete action button ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          this.dataSetup.action_buttons.splice(index || this.selectedIndexBtn, 1);
          if (this.isOpenConfigActionBtn) this.toggleConfigurationActionBtn(false);
          if (!onTable) this.setChangesValueView(true);
        }
      });
    },

    selectIconActionBtn(data) {
      const element = document.getElementById(this.idConfigIconActionBtn);
      if (element) element.classList.remove('show');

      setTimeout(() => {
        this.toggleModalIconActionBtn({ status: false, data });
      }, 300);
    },

    closeModalIconActionBtn() {
      const element = document.getElementById(this.idConfigIconActionBtn);
      if (element) element.classList.remove('show');

      setTimeout(() => {
        this.toggleModalIconActionBtn({ status: false, data: null });
      }, 300);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixSetupActionButton.js